export enum LogoutWarningResolution {
  ExtendSession = 0,
  Logout = 1,
}
